import { render } from "./RengongYlqRwKF2025Content.vue?vue&type=template&id=3130a783"
import script from "./RengongYlqRwKF2025Content.vue?vue&type=script&lang=js"
export * from "./RengongYlqRwKF2025Content.vue?vue&type=script&lang=js"

import "./RengongYlqRwKF2025Content.vue?vue&type=style&index=0&id=3130a783&lang=css"

import exportComponent from "F:\\allNewWeb\\ant-vue\\antd-demo2\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__